<template>
  <div class="payment-page style2">
    <div class="back-to-home">
      <router-link :to="{ name: 'paymentIntroduction' }" >
        <img src="@/assets/img/left-arrow.svg" alt="Back home" />
        <img src="@/assets/img/left-arrow-red.svg" alt="Back home" />
        <span>Trở về thanh toán trực tuyến</span>
      </router-link>
    </div>
    <h2 class="table-title">
      Xác nhận hợp đồng cần thanh toán qua Payoo
    </h2>
    <div class="contract-detail">
      <div
        class="flex flex-col-reverse xl:flex-row items-center"
      >
        <div class="w-full lg:w-full xl:w-3/5">
          <p class="contract-number">
            HỢP ĐỒNG SỐ {{contract.ContractNo}}
          </p>

          <div class="payment-detail-wrap">
            <p>CHI TIẾT SỐ TIỀN THANH TOÁN:</p>
            <ul class="payment-detail">
              <li>
                <div
                  class="flex justify-between"
                >
                  <p>Gốc:</p>
                  <p>{{Number(contract.OriginAmount).toLocaleString()}} VND</p>
                </div>
              </li>
              <li>
                <div
                  class="flex justify-between"
                >
                  <p>Lãi:</p>
                  <p>{{Number(contract.InterestAmount).toLocaleString()}} VND</p>
                </div>
              </li>
              <li>
                <div
                  class="flex justify-between"
                >
                  <p>Phạt trễ hạn:</p>
                  <p
                    class="highlight-color"
                  >
                    {{Number(contract.LateFee).toLocaleString()}} VND
                  </p>
                </div>
              </li>
              <li>
                <div
                  class="flex justify-between"
                >
                  <p>Tiền dư:</p>
                  <p>
                    {{Number(contract.ResidualAmount).toLocaleString()}} VND
                  </p>
                </div>
              </li>
              <li>
                <div
                  class="flex justify-between"
                >
                  <p>Số ngày trễ hạn:</p>
                  <p style="color: red">
                    {{contract.NumDayOverdue}}
                  </p>
                </div>
              </li>
            </ul>
            <hr />
            <div
              class="flex justify-between flex-col md:flex-col lg:flex-row"
            >
              <div
                class="mb-4 md:mb-4 lg:mb-0"
              >
                <p>
                  NGÀY ĐẾN HẠN THANH TOÁN:
                </p>
                <p
                  class="payment-history highlight-color"
                  v-if="contract.PaymentDueDate && contract.PaymentDueDate !== null"
                >
                  {{ contract.PaymentDueDate | dateParse('YYYY-MM-DD') | dateFormat('DD/MM/YYYY') }}
                </p>
                <p class="payment-history highlight-color" v-else></p>
              </div>
              <div>
                <p>
                  SỐ TIỀN CẦN THANH TOÁN:
                </p>
                <p
                  class="payment-history highlight-color text-left lg:text-right"
                >
                  {{Number(contract.TotalPaymentAmount).toLocaleString()}} VND
                </p>
              </div>
            </div>
          </div>
          <!--<router-link  class="contract-button" :to="{ name: 'paymentProcess', params: {contractNo: contract.ContractNo}}">
            thanh toán ngay {{Number(contract.PaymentAmount).toLocaleString()}}
          </router-link>-->
          <div class="payment-price">
            <div class="payment-price-label">Số Tiền Thanh Toán:</div>
            <div class="payment-price-input-field">
              <input
                :class="[ paymentAmountError ? 'payment-price-input--error' : '' ]"
                class="payment-price-input"
                type="text"
                min="10000"
                v-model="tmpAmount">
              <p v-if="paymentAmountError">* Số tiền thanh toán không hợp lệ</p>
            </div>
            <div class="payment-price-currency">VND</div>
          </div>
          <p class="payment-notices-text">
            * Quý khách có thể
            <i>điều chỉnh</i> số tiền thanh toán
            , số tiền thanh toán tối thiếu phải là 1 triệu
            và tối đa là 20 triệu
          </p>
          <button class="contract-button" @click="goToPayment" :disabled="!amount || paymentAmountError" v-if="$store.state.user.currentUser.IsHavePayment">
            thanh toán ngay {{Number(amount).toLocaleString()}}
          </button>
          <button class="contract-button" @click="isShownModal = true" :disabled="!amount || paymentAmountError" v-else>
            thanh toán ngay {{Number(amount).toLocaleString()}}
          </button>
          <hr />
          <div
            class="flex justify-between flex-col md:flex-col lg:flex-row"
          >
            <div class="mb-4 md:mb-4 lg:mb-0">
              <p>
                NGÀY THANH TOÁN GẦN NHẤT:
              </p>
              <p class="payment-history" v-if="contract.NearestPaymentDate && contract.NearestPaymentDate !== null">
                {{ contract.NearestPaymentDate | dateParse('YYYY-MM-DD') | dateFormat('DD/MM/YYYY') }}
              </p>
              <p class="payment-history" v-else>
              </p>
            </div>
            <div class="">
              <p>SỐ TIỀN ĐÃ THANH TOÁN:</p>
              <p
                class="text-left payment-history lg:text-right"
              >
                {{Number(contract.NearestPaymentAmount).toLocaleString()}}
              </p>
            </div>
          </div>
        </div>
        <div
          class="w-full lg:full xl:w-3/5 text-center"
        >
          <div class="contract-product">
            <img :src="`data:image/jpeg;base64,${contract.Car.Image}`" />
            <!--<p class="product-name">
              {{contract.Car.CarTypeName}}
            </p>-->
            <div class="car-number">
              {{contract.Car.PlateNo}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <UiModal closeOnOverlay :show.sync="isShownModal">
      <div class="update-email-form-modal">
        <div class="update-email-form-modal-close" @click="isShownModal = false"><img src="@/assets/img/icon-close.svg" alt="Close" /></div>
          <!--Body-->
          <div class="modal-content">
            <div class="modal-body">
             <p><center><b>Thông báo</b></center></p>
              <br>
             <p> - Nếu Quý khách đã có ví điện tử Payoo, vui lòng bấm "Tiếp tục" và thực hiện theo hướng dẫn của chương trình.</p>
             <p> - Nếu Quý khách chưa có ví điện tử Payoo, vui lòng bấm “Tạo ví ngay” để tạo ví điện tử Payoo trước khi thực hiện thanh toán.</p>
            </div>
          </div>
          <!--Footer-->
          <div class="modal-footer" style="display: flex;">
              <button class="modal-close mr-3" @click="goToPayment">
                Tiếp tục
              </button>
              <button class="modal-close" @click="goTo('https://www.payoo.vn/hop-tac-voi-payoo/vi-dien-tu-payoo/huong-dan-dang-ky')">
                Tạo ví ngay
              </button>
          </div>
      </div>
    </UiModal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
// import sha256 from 'sha256'
import { PaymentSummaryService } from '@/services/paymentSummary.service'
import UiModal from '@/components/UiModal.vue'

export default {
  name: 'PaymentDetail',
  components: {
    UiModal
  },
  data () {
    return {
      contractNo: this.$route.params.contractNo,
      // amount: 0,
      tmpAmount: 0,
      isShownModal: false
    }
  },
  watch: {
    tmpAmount: function (newValue) {
      const result = newValue.replace(/\D/g, '')
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      // eslint-disable-next-line no-return-assign
      this.$nextTick(() => this.tmpAmount = result)
    }
  },
  computed: {
    amount () {
      if (this.tmpAmount) {
        return String(this.tmpAmount).replace(/,/g, '')
      }
      return 0
    },
    ...mapState('payment', {
      contract: 'currentContract'
    }),
    paymentAmountError () {
      return Number(this.amount) < 1000000 || Number(this.amount) > 20000000
    }
    /* paymentUrl () {
      const checksum = sha256(`${this.contract.PayooResult.customerCode}${this.amount}${this.contract.PayooResult.txid}${this.contract.PayooResult.pnc}${this.contract.PayooResult.pass}`)
      return `${this.contract.PayooResult.link}?pnc=${this.contract.PayooResult.pnc}&custcode=${this.contract.PayooResult.customerCode}&amount=${this.amount}&txid=${this.contract.PayooResult.txid}&checksum=${checksum}`
    } */
  },
  methods: {
    async fetchData () {
      await this.$store.dispatch('payment/getCurrent', this.contractNo).then((result) => {
        this.tmpAmount = Number(result.TotalPaymentAmount).toLocaleString()
        if (result.Car && result.Car.BrandLogo !== '') {
          this.$bus.$emit('changeBrandLogo', result.Car.BrandLogo)
        }
      })
    },
    goTo (url) {
      // window.location.href = url
      window.open(url, '_blank')
    },
    goToPayment () {
      PaymentSummaryService.getPaymentInfo(this.contractNo, String(this.contractNo).substr(-6, 6), this.amount).then((result) => {
        if (result.data.data.Link) {
          window.location.href = result.data.data.Link
        } else {
          this.$store.commit('toast/NEW', {
            type: 'error',
            message: 'Có lỗi xảy ra! Vui lòng liên hệ hỗ trợ khách hàng để biết thêm chi tiết.'
          })
        }
      })
    }
  },
  created () {
    /* if (this.$route.query.rescode) {
      if (this.$route.query.rescode !== '1' && this.$route.query.rescode !== '2') {
        this.$store.commit('toast/NEW', {
          type: 'error',
          message: 'Thanh toán thất bại! Vui lòng liên hệ hỗ trợ khách hàng để biết thêm chi tiết.'
        })
        const query = Object.assign({}, this.$route.query)
        delete query.rescode
        this.$router.replace({ query })
      } else {
        this.$router.push({ path: '/payment/success', query: { amount: this.$route.query.amount, contractNo: this.contractNo } })
      }
    } */
    this.fetchData()
  },
  destroyed () {
    this.$bus.$emit('changeBrandLogo')
  }
}
</script>

<style lang="scss" scoped>
  @import '@/scss/components/_paymentPrice.scss';
</style>
